import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import {Routes, Route, Link, Navigate} from "react-router-dom";
import {BrowserRouter} from "react-router-dom";
import HomePage from "./pages/home";
import ErrorPage from "./pages/error";
import ProfilesPage from "./projects/docx-profile";
import InfoProfilePage from "./projects/info-profile";
import InfoComponent from "./componennts/info";
import Fact_Profile_V1 from "./projects/fact-profile/v1/factologichne_vuklad_profile_v1";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <BrowserRouter>
          <Routes>
              <Route index exact path={'/'} element={<App />}/>

              <Route exact path={'/projects'} element={<HomePage />}/>

              <Route exact path={'/profile'} element={<ProfilesPage />}/>
              <Route exact path={'/info-file'} element={<InfoProfilePage />}/>
              <Route exact path={'/fact-file'} element={<Fact_Profile_V1 />}/>


              <Route exact path={'/info'} element={<InfoComponent />}/>

              <Route path="*" element={<ErrorPage />}/>
          </Routes>
      </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
